export const viewLocationDetailsSaga = (state) => state.transactionReducer.viewLocationDetails;
export const viewLocationDetailsErrorSaga = (state) => state.transactionReducer.viewLocationDetailsError;
